class ResourceList {
	constructor(container) {
		this._container = ge(container);
		this._resources = [];
		this._activeItem = null;

		this.selection = new SelectionMgr();
		this.tags = new TagList(TagList.RESOURCES, this);
		this.sharing = new Sharing(Sharing.RESOURCE);
		this.access = new Access(Access.RESOURCE);

		this.selection.addButton(
			this.selectionTagBtn = UI.priIconBtn('tags', 18, {
				'click': () => this.getTags(this.selection.ids, this.selectionTagBtn)
			})
		);
		this._selAccessBtn = UI.priIconBtn('share', 18, {
			'mousedown': ev => stopEv(ev),
			'click': ev => this.access.open(this.selection.ids, ev.currentTarget)
		});
		this.selection.addButton(this._selAccessBtn);

		this.orderBy = ge('order-by');
		this.searchText = ge('search-text');
		this.filters = new FilterList();

		this.filters.addGroup('Sources', 'source', new Sources('resources'));
		this.filters.addGroup('Tags', 'tag', this.tags);

		onEv(this.orderBy, 'change', this.getList.bind(this));
		onEv(this.searchText, 'keyup paste', this.getList.bind(this));

		ge('sticky-bar').appendChild(UI.div('flex-0', [
			nav.userCan(MemberPermission.ADD_RESOURCES)
				? this.newResourceBtn = UI.priIconBtn('plus-square', 18, {'click': this.newResource.bind(this)})
				: null,
			nav.userCan(MemberPermission.ADMIN) && nav.isCircle
				? new ContentFilter(MemberPermission.FILTER_RESOURCES, this.getList.bind(this)).button
				: null,
			UI.priIconBtn('tags', 18, {'click': this.openTags.bind(this)}),
			this.filters.button
		]));

		this.newResourceMenu = Dialog.Popup([
			btn('popup-list-btn', _("Guide"), {
				'click': () => {
					location.assign('/guide?' + nav.params());
				}
			}),
			btn('popup-list-btn', _("Checklist"), {
				'click': () => {
					location.assign('/checklist?' + nav.params());
				}
			})
		]);
		this.emptyState = null;
		onEv(document, 'primaryDataInvalid filterSelected', this.getList.bind(this));
		this.getList();
	}

	getList() {
		API.fetch('items', {
			order: this.orderBy.value,
			search: this.searchText.value,
			source: this.filters.getGroup('source'),
			tag: this.filters.getGroup('tag')
		})
		.then(json => {
			if (showError(json)) return;
			this._container.innerHTML = '';
			this._resources = [];

			if (json.resources && Array.isArray(json.resources)) {
				if (this.emptyState !== null) this.emptyState.remove();
				if (json.resources.length == 0) {
					this._container.appendChild(this.emptyState = UI.div('no-content', [
						UI.htm('h2', null, _("More empty space, to be replaced!")),
						UI.img(null, '/images/space/planet.png'),
						UI.p(null, [
							// btn('btn', img(null, '/images/space/video-btn.png'), {
							// 	'click': () => pageFlow.fromStart(2)
							// }),
							UI.btn('', UI.img(null, '/images/space/guide-btn.png'), {
								'click': () => pageFlow.fromStart(8)
							})
						])
					]));
				}
				json.resources.forEach(data => {
					let resource = Resource.fromArray(data, this);
					this._resources.push(resource);
					this._container.appendChild(resource.elem);
				});
				if (json.access_summary) {
					for (let s of json.access_summary) {
						this.access.setSummary(parseInt(s.id), parseInt(s.view_count), parseInt(s.edit_count), json.unit_count);
					}
				}
				if (json.sharing_summary) {
					for (let s of json.sharing_summary) {
						this.sharing.setCount(parseInt(s.id), parseInt(s.share_count));
					}
				}
				document.dispatchEvent(new Event('primaryDataLoaded'));
			}
		});
	}

	newResource() {
		this.newResourceMenu.handle(this.newResourceBtn);
	}

	openTags() {
		this.tags.openDialog();
	}

	getTags(ids, button) {
		this._selectionIds = Array.isArray(ids) ? ids : [ids];

		this.tags.reset();
		this.tags.popup(button);

		API.fetch(
			'items/tags',
			{
				items: this._selectionIds
			}
		)
		.then(reply => {
			if (showError(reply)) return;
			if (reply.items) {
				for (let i of reply.items) {
					if (this._selectionIds.indexOf(i.item_id) === -1) continue;
					this.tags.increment(i.tag_id, this._selectionIds.length); 
				}
			}
		});
	}

	toggleTag(tag) {
		if (tag.isSet) {
			API.insert(
				`items/tags`,
				{
					items: this._selectionIds,
					tag: tag.id
				}
			)
			.then(reply => {
				showError(reply);
			});
		}
		else {
			API.delete(
				'items/tags',
				{
					items: this._selectionIds,
					tag: tag.id
				}
			)
			.then(reply => {
				showError(reply);
			});
		}
	}
}